/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindLeaveReasonQueryResponse } from './FindLeaveReasonQueryResponse';
import {
    FindLeaveReasonQueryResponseFromJSON,
    FindLeaveReasonQueryResponseFromJSONTyped,
    FindLeaveReasonQueryResponseToJSON,
} from './FindLeaveReasonQueryResponse';
import type { ListMeta } from './ListMeta';
import {
    ListMetaFromJSON,
    ListMetaFromJSONTyped,
    ListMetaToJSON,
} from './ListMeta';

/**
 * 
 * @export
 * @interface ListLeaveReasonQueryResponse
 */
export interface ListLeaveReasonQueryResponse {
    /**
     * 
     * @type {ListMeta}
     * @memberof ListLeaveReasonQueryResponse
     */
    meta: ListMeta;
    /**
     * 
     * @type {Array<FindLeaveReasonQueryResponse>}
     * @memberof ListLeaveReasonQueryResponse
     */
    data: Array<FindLeaveReasonQueryResponse>;
}

/**
 * Check if a given object implements the ListLeaveReasonQueryResponse interface.
 */
export function instanceOfListLeaveReasonQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "meta" in value;
    isInstance = isInstance && "data" in value;

    return isInstance;
}

export function ListLeaveReasonQueryResponseFromJSON(json: any): ListLeaveReasonQueryResponse {
    return ListLeaveReasonQueryResponseFromJSONTyped(json, false);
}

export function ListLeaveReasonQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLeaveReasonQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': ListMetaFromJSON(json['meta']),
        'data': ((json['data'] as Array<any>).map(FindLeaveReasonQueryResponseFromJSON)),
    };
}

export function ListLeaveReasonQueryResponseToJSON(value?: ListLeaveReasonQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': ListMetaToJSON(value.meta),
        'data': ((value.data as Array<any>).map(FindLeaveReasonQueryResponseToJSON)),
    };
}

